import {
  FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE, FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_FAILURE, USER_REGISTER_REQUEST, USER_REGISTER_SUCCESS, USER_REGISTER_FAIL, UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
} from './types';
import { fetchUsers, registerUser, fetchProfile, updateUserAdmin } from "../../services/userService";

// Action Creators for Fetching Users
export const fetchUsersRequest = () => ({ type: FETCH_USERS_REQUEST });
export const fetchUsersSuccess = (usersData) => ({
  type: FETCH_USERS_SUCCESS,
  payload: usersData,
});
export const fetchUsersFailure = (error) => ({
  type: FETCH_USERS_FAILURE,
  payload: error,
});

// Thunk to fetch users
export const fetchUsersAction = (page = 1, size = 1000) => async (dispatch) => {
  dispatch(fetchUsersRequest());

  try {
    const response = await fetchUsers(page, size);

    if (response.error) {
      dispatch(fetchUsersFailure(response.error));
      return { success: false, error: response.error };
    } else {
      dispatch(fetchUsersSuccess(response));
      return { success: true, data: response };
    }
  } catch (error) {
    dispatch(fetchUsersFailure(error.message || "Failed to fetch users"));
    return { success: false, error: error.message || "Failed to fetch users" };
  }
};

// Action Creators for Registering a User
export const registerUserRequest = () => ({ type: USER_REGISTER_REQUEST });
export const registerUserSuccess = (userData) => ({
  type: USER_REGISTER_SUCCESS,
  payload: userData,
});
export const registerUserFail = (error) => ({
  type: USER_REGISTER_FAIL,
  payload: error,
});

// Thunk to register a new user
export const registerUserAction = (userDetails) => async (dispatch) => {
  dispatch(registerUserRequest());

  try {
    const data = await registerUser(userDetails);
    dispatch(registerUserSuccess(data));
    return { success: true, data };
  } catch (error) {
    // Clean up error message
    let errorMessage = error.message;

    // Remove "body." prefixes if they exist
    errorMessage = errorMessage.replace(/body\./g, '');

    // Capitalize first letter of each error line
    errorMessage = errorMessage.split('\n').map(line =>
      line.charAt(0).toUpperCase() + line.slice(1)
    ).join('\n');

    dispatch(registerUserFail(errorMessage));
    return { success: false, error: errorMessage };
  }
};

// Action Creators for Fetching Users
export const fetchUserRequest = () => ({ type: FETCH_USER_REQUEST });
export const fetchUserSuccess = (userData) => ({
  type: FETCH_USER_SUCCESS,
  payload: userData,
});
export const fetchUserFailure = (error) => ({
  type: FETCH_USER_FAILURE,
  payload: error,
});

export const getUserProfile = () => async (dispatch) => {
  dispatch(fetchUserRequest());
  try {
    const response = await fetchProfile();
    if (response.success) {
      dispatch(fetchUserSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      dispatch(fetchUserFailure(response.error));
      return { success: false, error: response.error };
    }
  } catch (error) {
    dispatch(fetchUserFailure(error.message || "Failed to fetch user profile"));
    return { success: false, error: error.message || "Failed to fetch user profile" };
  }
};

// action creators
export const updateUserRequest = () => ({
  type: UPDATE_USER_REQUEST,
});

export const updateUserSuccess = (user) => ({
  type: UPDATE_USER_SUCCESS,
  payload: user,
});

export const updateUserFailure = (error) => ({
  type: UPDATE_USER_FAILURE,
  payload: error,
});

// thunk
export const updateUserAction = (userId, payload) => async (dispatch) => {
  dispatch(updateUserRequest());

  try {
    const response = await updateUserAdmin(userId, payload);

    if (response.success) {
      dispatch(updateUserSuccess(response.data));
      return response;
    } else {
      dispatch(updateUserFailure(response.error));
      throw new Error(response.error);
    }
  } catch (error) {
    dispatch(updateUserFailure(error.message));
    throw error;
  }
};